// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2EaWu";
var _4 = "title-1DDzI";
var _5 = "right-SkSXT";
var _6 = "priceWrapper-1OY8a";
var _7 = "originalPrice-j3m_9";
var _8 = "price-1zmQO";
var _9 = "unavailable-PJtcL";
var _a = "miles-nunug";
var _b = "miles__amount-3qabg";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "title", _5 as "right", _6 as "priceWrapper", _7 as "originalPrice", _8 as "price", _9 as "unavailable", _a as "miles", _b as "miles__amount" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "title": _4, "right": _5, "priceWrapper": _6, "originalPrice": _7, "price": _8, "unavailable": _9, "miles": _a, "miles__amount": _b }
